module.exports = __webpack_public_path__ + "c1c5e091b492b59349bd74f090951378.png";